function snapToInterval(minutes, intervalMinutes) {
  if (intervalMinutes <= 1) return Math.min(59, Math.max(0, minutes));
  const snapped = Math.round(minutes / intervalMinutes) * intervalMinutes;
  return Math.min(59, Math.max(0, snapped));
}

function calendarBaseDate(selected) {
  if (selected instanceof Date && !Number.isNaN(selected.getTime())) {
    return new Date(selected.getFullYear(), selected.getMonth(), selected.getDate());
  }
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

/**
 * Parses partial typed time (e.g. "8" -> 08:00, "830" -> 08:30) for HH:mm-style entry.
 * @param {string} raw
 * @param {Date|null|undefined} selected existing value for calendar day context
 * @param {number} intervalMinutes e.g. 5 for react-datepicker timeIntervals
 * @returns {Date|null} null if empty/invalid
 */
export function parsePartialTimeInput(raw, selected, intervalMinutes = 5) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (s === "") return null;

  const normalized = s.replace(/[^\d:]/g, "");
  if (normalized === "") return null;

  let hour;
  let minute;

  const colonIdx = normalized.indexOf(":");
  if (colonIdx !== -1) {
    const hStr = normalized.slice(0, colonIdx);
    const mStr = normalized.slice(colonIdx + 1);
    if (hStr === "") return null;
    hour = parseInt(hStr, 10);
    if (Number.isNaN(hour) || hour > 23) return null;

    if (mStr === "") {
      minute = 0;
    } else if (mStr.length === 1) {
      const d = parseInt(mStr, 10);
      if (Number.isNaN(d)) return null;
      minute = d <= 5 ? d * 10 : d;
    } else {
      minute = parseInt(mStr.slice(0, 2), 10);
      if (Number.isNaN(minute) || minute > 59) return null;
    }
  } else {
    const digits = normalized;
    if (digits.length === 1) {
      const d = parseInt(digits, 10);
      if (Number.isNaN(d)) return null;
      // 1–2 alone are ambiguous (e.g. "1" could be 01:00 or start of "18"); wait for more digits.
      if (d === 1 || d === 2) return null;
      hour = d;
      minute = 0;
    } else if (digits.length === 2) {
      hour = parseInt(digits, 10);
      if (Number.isNaN(hour) || hour > 23) return null;
      minute = 0;
    } else if (digits.length === 3) {
      hour = parseInt(digits[0], 10);
      minute = parseInt(digits.slice(1), 10);
      if (Number.isNaN(hour) || Number.isNaN(minute) || hour > 23 || minute > 59) return null;
    } else {
      hour = parseInt(digits.slice(0, 2), 10);
      minute = parseInt(digits.slice(2, 4), 10);
      if (Number.isNaN(hour) || Number.isNaN(minute) || hour > 23 || minute > 59) return null;
    }
  }

  minute = snapToInterval(minute, intervalMinutes);
  const base = calendarBaseDate(selected);
  base.setHours(hour, minute, 0, 0);
  return base;
}
